import React from 'react';
import { Container, Typography, Box, Grid, Paper, List, ListItem, ListItemText } from '@mui/material';
import { useParams } from 'react-router-dom';
import portfolio from '../data/portfolioData';
import ImageLightbox from './ImageLightbox';

export default function PortfolioDetail() {
  const { slug } = useParams();
  const item = portfolio.find(p => p.slug === slug) || null;

  React.useEffect(() => {
    if (item) document.title = `${item.title} — NehaInfoTech`;
    return () => { document.title = 'NehaInfoTech'; };
  }, [item]);

  const [open, setOpen] = React.useState(false);

  if (!item) {
    return (
      <Container sx={{ py: 6 }}>
        <Typography variant="h4">Case study not found</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>{item.title}</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>{item.category}</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={8}>
          <Box>
            <Box component="img" src={item.image} onClick={() => setOpen(true)} sx={{ width: '100%', height: 420, objectFit: 'cover', borderRadius: 2, cursor: 'pointer' }} />
            {item.caption && (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>{item.caption}</Typography>
            )}
            <ImageLightbox open={open} onClose={() => setOpen(false)} src={item.image} alt={item.title} caption={item.caption} />
          </Box>
          <Typography sx={{ mt: 3 }}>{item.overview}</Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }} elevation={2}>
            <Typography variant="h6">Key results</Typography>
            <List>
              {item.results.map(r => (
                <ListItem key={r}><ListItemText primary={r} /></ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
